const carousel = require('./delivery-carousel');
const scrollAnimate = require('sfraScripts/components/scrollAnimate');

const fieldSelectors = [
	'input[name$=_firstName]',
	'input[name$=_lastName]',
	'input[name$=_address1]',
	'input[name$=_streetName]',
	'input[name$=_streetNumber]',
	'input[name$=_city]',
	'input[name$=_postalCode]',
	'select[name$=_stateCode]',
	'input[name$=_phone]',
	'input[name$=_email]',
];

const matchingAddressForms = () => {
	let matching = true;

	for (let i = 0; i < fieldSelectors.length; i++) {
		const fields = $(fieldSelectors[i]);
		if (fields.length > 1 && fields[0].value !== fields[1].value) {
			matching = false;
			break;
		}
	}

	return matching;
};

const copyShippingToBilling = () => {
	for (let i = 0; i < fieldSelectors.length; i++) {
		const fields = $(fieldSelectors[i]);
		if (fields.length > 1) {
			fields[1].value = fields[0].value;
		}
	}
};

const prePopulateBilling = () => {
	for (let i = 0; i < fieldSelectors.length; i++) {
		const fields = $(fieldSelectors[i]);
		if (fields.length > 1 && !fields[1].value) {
			fields[1].value = fields[0].value;
		}
	}
};

const setBillingAddressListener = () => {
	const matching = matchingAddressForms();
	const $sameAddressCheck = $('#shippingAddressUseAsBillingAddress');
	const $billingForm = $('.billing-form');
	const shippingFormHasValue = $('.shipping-form').find('input[name$="_address1"]').val();
	var isBillingCollapsed = $billingForm.hasClass('collapsed');
	var pickupBillingAddress = $billingForm.hasClass('pickupBillingAddress');

	if ($sameAddressCheck.length) {
		$($sameAddressCheck).on('change', function (e) {
			if (e.currentTarget.checked) {
				$billingForm.removeClass('collapsed');
				$billingForm.find('.billing-fieldset .pickup-selected').removeClass('d-none');
			} else if (pickupBillingAddress) {
				$billingForm.find('.billing-fieldset .pickup-selected').addClass('d-none');
			} else {
				$billingForm.addClass('collapsed');
			}
		});

		if (isBillingCollapsed || pickupBillingAddress) {
			$sameAddressCheck.prop('checked', false);
		} else {
			$sameAddressCheck.prop('checked', true);
		}

		$('body').on('click', '.modify-billing-address', function () {
			$('.billing-form').find('.has-billing-address').addClass('d-none');
			$('.no-billing-address').removeClass('block-disable');
			$('.disclaimer').removeClass('d-none');
			$('#billingFullAddress').removeClass('d-none');
		});
	}
};

const watchShippingAddressSelector = () => {
	$('#shippingSelectorEdit').off();
	$('body').on('click', '#shippingSelectorEdit', function () {
		$('.shipping-address-block').removeClass('d-none');
	});
};

const watchCheckboxSelector = () => {
	var $smsAndEmailSubscription = $('input[name$=_smsAndEmailSubscription]');

	$smsAndEmailSubscription.prop('checked', !!$smsAndEmailSubscription.attr('data-value'));
}

const handleShippitAuthority = () => {
	const $clickableElements = $('#shippitAuthorityToLeave, label[for="shippit_authority_to_leave"]');
	$clickableElements.off();
	$clickableElements.click(function() {
		const $checkbox = $('#shippitAuthorityToLeave');
		const value = $checkbox.prop('checked');
		$checkbox.prop('checked', !value); // Toggle temporarily for immediate visual feedback
		const url = $checkbox.attr('data-submit-url');

		$.post(url, {shippit_authority_to_leave: !value}, function(data) {
			let newValue = value;
			if (data.success) {
				newValue = data.savedValue === 'true';
			}
			$checkbox.prop('checked', newValue);
		});
	});
};

const handleStoringBilling = () => {
	$('#addGiftCert, .edit-button').click(function() {
		const billingAddressForm = $('#dwfrm_billing .billing-address-block :input').serialize();
		localStorage.setItem('billing-form', billingAddressForm);
	});

	const storedForm = localStorage.getItem('billing-form');

	if (storedForm) {
		const form = JSON.parse(
			`{"${decodeURI(storedForm)
				.replace(/"/g, '\\"')
				.replace(/&/g, '","')
				.replace(/=/g, '":"')}"}`,
		);

		for (const fieldKey in form) {
			if (form[fieldKey]) {
				const formField = $(`[name='${fieldKey}']`);
				if (!formField.val()) {
					formField.val(form[fieldKey]);
				}
			}
		}

		localStorage.removeItem('billing-form');
	}
};

const initialise = (stages, currentStage) => {
	const stage = stages[currentStage];
	switch (stage) {
		case 'shipping':
			watchShippingAddressSelector();
			watchCheckboxSelector();

			setBillingAddressListener();
			prePopulateBilling();
			handleStoringBilling();

			carousel.deliveryCarousel();
			handleShippitAuthority();
			break;
		case 'payment':
			var $afterPayError = $('#checkout-main').find('.after-pay-error');
			if ($afterPayError) {
				window.scrollTo(0, 0);
			} else {
				scrollAnimate($('.payment-form'));
			}
			break;
		case 'placeOrder':
			break;
		case 'submitted':
			break;
	}
};

const stepChange = (stages, nextStage) => {
	switch (stages[nextStage]) {
		case 'shipping':
			watchShippingAddressSelector();
			watchCheckboxSelector();

			setBillingAddressListener();
			prePopulateBilling();
			handleStoringBilling();

			carousel.deliveryCarousel();
			handleShippitAuthority();
		case 'payment':
			break;
	}
};

module.exports = {
	initialise: initialise,
	stepChange: stepChange,
	shippingBillingMatch: matchingAddressForms,
	copyShippingToBilling: copyShippingToBilling,
	getEmail: () => {
		const $el = $('.shippingEmail, .billingEmail');
		return !$el || $el.val() === 'null' ? null : $el.val();
	},
};
